import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "messages-container" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageNotification = _resolveComponent("MessageNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      name: "messages",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$store.state.msg.messages, ([id, message]) => {
          return (_openBlock(), _createElementBlock("div", { key: id }, [
            _createVNode(_component_MessageNotification, { message: message }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "delete",
                  onClick: ($event: any) => (_ctx.onMessageClose(id))
                }, null, 8, _hoisted_2)
              ]),
              _: 2
            }, 1032, ["message"])
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}